import { CalendarDays, Clock, Check } from 'lucide-react'
import { Button } from 'components/Button'
import { TreatmentPlansActions } from 'store/actions';
import { connect } from 'react-redux';
import toast from 'react-hot-toast'
import { useState } from 'react';

let enhancer = connect(null, { ...TreatmentPlansActions });

const ScheduleStep = ({ treatmentPlanId, baseAppointmentId, onNext, createTreatmentPlanProgress }) => {
  const [isScheduling, setIsScheduling] = useState(false);

  const handleSchedule = async () => {
    setIsScheduling(true);
    try {
      await createTreatmentPlanProgress(treatmentPlanId, {
        treatment_plan_progress: {
          treatment_plan_id: treatmentPlanId,
          originated_appointment_id: baseAppointmentId,
          patient_request_type: "same_day"
        }
      });

      toast.success('Schedule created successfully');
      onNext();
    } catch (error) {
      toast.error(error?.errors || 'Failed to schedule');
    }
    setIsScheduling(false);
  };

  return (
    <div className="w-full space-y-6 py-6 animate-in fade-in duration-300">
      <div className="text-center space-y-3">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 text-blue-600 shadow-xs mb-1">
          <CalendarDays size={28} className="stroke-[1.8]" />
        </div>
        <h2 className="text-xl font-bold text-secondary-900 tracking-tight">Schedule Treatment</h2>
        <p className="text-sm text-secondary-500 max-w-md mx-auto">
          Tell us your scheduling preferences and we'll make it work.
        </p>
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="flex items-start gap-4 p-6 rounded-2xl border-2 border-green-500/80 bg-green-50/20 shadow-md shadow-green-100/10 select-none">
          <div className="mt-1 flex items-center justify-center shrink-0">
            <div className="w-5 h-5 rounded-full border-2 border-green-500 bg-white flex items-center justify-center">
              <div className="w-2.5 h-2.5 rounded-full bg-green-500" />
            </div>
          </div>

          <div className="flex-1 space-y-4">
            <div className="flex items-center gap-2">
              <span className="p-1.5 rounded-lg flex items-center justify-center shrink-0 bg-green-100 text-green-600">
                <Clock size={16} className="stroke-[2.5]" />
              </span>
              <h3 className="text-sm sm:text-base font-extrabold text-secondary-900 leading-snug">
                I'd love to get it done today if possible!
              </h3>
            </div>

            <p className="text-xs sm:text-sm text-secondary-500 leading-relaxed">
              Let us know your availability today and we'll do our best to accommodate you.
            </p>

            <div className="p-4 rounded-xl border bg-white border-green-200/60 shadow-xs">
              <div className="flex items-center gap-2.5">
                <span className="p-1 rounded-full flex items-center justify-center shrink-0 bg-green-50 text-green-600">
                  <Check size={12} className="stroke-[3]" />
                </span>

                <span className="text-xs font-semibold leading-normal text-green-700">
                  We'll check our schedule and let you know what's possible.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center mt-6">
        <Button
          title="Schedule Treatment Plan"
          variant="tertiary"
          icon={<CalendarDays size={16} />}
          onClick={handleSchedule}
          disabled={isScheduling}
          loading={isScheduling}
        />
      </div>
    </div>
  )
}

export default enhancer(ScheduleStep)
